module.exports = __webpack_public_path__ + "static/media/rules-step-02.f8745bbb.png";